import { render, staticRenderFns } from "./ChannelLists.vue?vue&type=template&id=04693d4b"
import script from "./ChannelLists.vue?vue&type=script&lang=js"
export * from "./ChannelLists.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports